// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"d3dadd43","487":"d3e99e05"}[chunkId] + ".chunk.js";
};